import React, { useContext, useEffect, useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import Select from 'react-select';
import './FilterSearch.css';
import fraga from '../controller/api/Fraga';
import newFraga from '../controller/api/New_Fraga'
import aplications from '../controller/api/Aplications';
import { GetUserContext } from '../Context/GetUserContext';
import Load from './Load';
import { MdCheckBoxOutlineBlank } from "react-icons/md";
import { MdCheckBox } from "react-icons/md";
import { IoCloseCircle } from "react-icons/io5";
import company from '../controller/api/Company';


const FilterSearch = () => {
    const {
        fabricanteArray, take, setTake, selectedFabricante, setSelectedFabricante, nomePeca, axiosConfig,
        setNamePeca, selectedBrands, setSelectedBrands, selectedNames, setSelectedNames,
        selectedModels, setSelectedModels, selectedAllYears, setSelectedAllYears, selectedEnginer,
        setSelectedEnginer, selectedEnginerConfig, setSelectedEnginerConfig, setOrdenarPreco,
        setProducts, products, setLoad, filterEstoque, setFilterEstoque, setCurrentPage, setTotalPages,
        size, page, setPage, activedPagination, setActivedPagination
    } = useContext(GetUserContext)

    const [idCompany, setIdCompany] = useState(0)
    const [required, setRequired] = useState(true)
    const NewFraga = new newFraga();
    const newUser = new company();

    useEffect(() => {
        newUser.getCompany(axiosConfig)
            .then(userDatas => {
                setIdCompany(userDatas?.data?.Company_ID)
            }).catch(err => { return err })
    }, [])

    //brands
    const [selectedOptionFabricates, setSelectedOptionFabricates] = useState(null);
    const optionsMontadoras = [];
    const [optionsFabricantes, setOptionsFabricantes] = useState([]);

    useEffect(() => {
        const options = fabricanteArray.map(fabricante => ({
            value: fabricante?.ID_Fabricante,
            label: fabricante?.Nome_Fabricante
        }));

        setOptionsFabricantes(options);
    }, [fabricanteArray]);



    const handleChangeFabricante = (optionsFabricantes) => {
        setSelectedOptionFabricates(optionsFabricantes);
        setSelectedFabricante(optionsFabricantes?.label)
    };


    const [selectedOptionBrands, setSelectedOptionBrands] = useState(null);
    const [selectedOptionNames, setSelectedOptionNames] = useState(null);
    const [selectedOptionModels, setSelectedOptionModels] = useState(null);
    const [selectedOptionAllYears, setSelectedOptionAllYears] = useState(null);
    const [selectedOptionEnginer, setSelectedOptionEnginer] = useState(null);
    const [selectedOptionEnginerConfig, setSelectedOptionEnginerConfig] = useState(null);

    const optionsBrands = [];
    const optionsNames = [];
    const optionsModel = [];
    const optionsAllYars = [];
    const optionsEnginer = [];
    const optionsEnginerConfig = [];

    useEffect(() => {

        NewFraga.selectBrands()
            .then(response => {
                const brandsArray = response?.data.vehicleBrands

                brandsArray.map((brand, index) => {
                    optionsBrands.push({ value: (index + 1), label: brand })
                })
            })
            .catch(err => {
                return console.log(err)
            })
    }, [NewFraga])

    useEffect(() => {

        if (!selectedBrands.length == 0) {

            NewFraga.selectNames(selectedBrands)
                .then(response => {
                    const namesArray = response?.data.vehicleNames

                    namesArray.map((name, index) => {
                        optionsNames.push({ value: (index + 1), label: name })
                    })

                })
                .catch(err => {
                    return console.log(err)
                })

        }

    }, [NewFraga, selectedBrands])

    useEffect(() => {

        if (!selectedNames.length == 0) {
            NewFraga.selectModel(selectedNames)
                .then(response => {
                    const modelArray = response?.data.vehicleModels

                    modelArray.map((name, index) => {
                        optionsModel.push({ value: (index + 1), label: name })
                    })
                })
                .catch(err => {
                    return console.log(err)
                })
        }
    }, [NewFraga, selectedNames])

    useEffect(() => {

        if (!selectedNames.length == 0 && !selectedModels.length == 0) {
            NewFraga.selectAllYears(selectedNames, selectedModels)
                .then(response => {
                    const allYearsArray = response?.data.vehicleYears
                    allYearsArray.map((name, index) => {
                        optionsAllYars.push({ value: (index + 1), label: name })
                    })
                })
                .catch(err => {
                    return console.log(err)
                })
        }


    }, [NewFraga, selectedNames, selectedModels])

    useEffect(() => {

        if (!selectedAllYears.length == 0) {
            NewFraga.selectEnginer(selectedAllYears)
                .then(response => {
                    const modelEnginer = response?.data.vehicleEngineNames

                    modelEnginer.map((enginer, index) => {
                        optionsEnginer.push({ value: (index + 1), label: enginer })
                    })
                })
                .catch(err => {
                    return console.log(err)
                })

        }


    }, [NewFraga, selectedAllYears])

    useEffect(() => {

        if (!selectedEnginer.length == 0) {
            NewFraga.selectEnginerConfig(selectedEnginer)
                .then(response => {
                    const modelEnginerConfig = response?.data.vehicleEngineConfigurations

                    modelEnginerConfig.map((enginerConfig, index) => {
                        optionsEnginerConfig.push({ value: (index + 1), label: enginerConfig })
                    })
                })
                .catch(err => {
                    return console.log(err)
                })

        }


    }, [NewFraga, selectedEnginer])

    //functions
    const handleChangeBrands = (optionsBrands) => {
        setSelectedOptionBrands(optionsBrands);
        setSelectedBrands(optionsBrands?.label);
    };

    const handleChangeNames = (optionsNames) => {
        setSelectedOptionNames(optionsNames);
        setSelectedNames(optionsNames?.label);
    };

    const handleChangeModels = (optionsModel) => {
        setSelectedOptionModels(optionsModel);
        setSelectedModels(optionsModel?.label);
    };

    const handleChangeAllYears = (optionsAllYars) => {
        setSelectedOptionAllYears(optionsAllYars);
        setSelectedAllYears(optionsAllYars?.label);
    };

    const handleChangeEniner = (optionsEnginer) => {
        setSelectedOptionEnginer(optionsEnginer);
        setSelectedEnginer(optionsEnginer?.label);
    };

    const handleChangeEninerConfig = (optionsEnginerConfig) => {
        setSelectedOptionEnginerConfig(optionsEnginerConfig);
        setSelectedEnginerConfig(optionsEnginerConfig?.label);
    };
    //PesquisaFinal
    const searchParts = (e) => {
        e.preventDefault()
        setLoad(true);
    }
    const handleFilterEstoque = () => {
        setFilterEstoque(prevState => !prevState);
    };

    useEffect(() => {
        if (selectedBrands?.length > 0) {
            setRequired(false)
        } else if (selectedFabricante?.length > 0) {
            setRequired(false)
        } else {
            setRequired(true)
        }

    }, [selectedFabricante, selectedBrands, required])



    const handleClearBrands = () => {
        if (!selectedNames.length > 0) {
            setSelectedOptionBrands([])
            setSelectedBrands('')
        }
    }

    const handleClearNames = () => {
        if (!selectedModels.length > 0) {
            setSelectedOptionNames([])
            setSelectedNames('')
        }
    }

    const handleClearModels = () => {
        if (!selectedAllYears.length > 0) {

            setSelectedOptionModels([])
            setSelectedModels('')
        }
    }

    const handleClearYear = () => {
        if (!selectedEnginer.length > 0) {
            setSelectedOptionAllYears([])
            setSelectedAllYears('')
        }
    }

    const handleClearEnginer = () => {
        if (!selectedEnginerConfig.length > 0) {
            setSelectedOptionEnginer([])
            setSelectedEnginer('')
        }
    }

    const handleClearEnginerConfig = () => {
        setSelectedOptionEnginerConfig([])
        setSelectedEnginerConfig('')
    }

    const handleFabricantes = () => {
        setSelectedOptionFabricates([])
        setSelectedFabricante('')
    }


    const handleNome = (e, page = 1) => {
        e.preventDefault();
        setLoad(true);

        NewFraga.prodName(
            nomePeca,
            selectedBrands,
            selectedNames,
            selectedModels,
            selectedAllYears,
            selectedEnginer,
            selectedEnginerConfig,
            selectedFabricante,
            idCompany,
            page
        )
            .then(response => {
                console.log(response)
                setProducts(response.filteredProducts);
                setTotalPages(Math.ceil(response.totalFiltered / take));
                setCurrentPage(page);
                setLoad(false);
            })
            .catch(err => {
                console.error("Erro ao buscar produtos:", err);
                setLoad(false);
            });
    };

    console.log(selectedFabricante)

    const handleNomeTESTE = (e) => {
        e.preventDefault();
        setLoad(true);

        if (selectedBrands?.length !== 0 || selectedFabricante?.length !== 0) {
            console.log('pesquisar pela api')

            NewFraga.prodName(
                nomePeca,
                selectedBrands,
                selectedNames,
                selectedModels,
                selectedAllYears,
                selectedEnginer,
                selectedEnginerConfig,
                selectedFabricante,
                idCompany,
                page)
                .then(response => {
                    setPage(1)
                    setActivedPagination(true);
                    setProducts(response);
                    setTotalPages(Math.ceil(response.totalFiltered / take));
                    setCurrentPage(page);
                    setLoad(false);
                })
                .catch(err => {
                    console.error("Erro ao buscar produtos:", err);
                    setLoad(false);
                });
            setLoad(false);
        }
        else {
            console.log('pesquisar pelo nome')

            NewFraga.prodNameTESTE(nomePeca, idCompany)
                .then(response => {
                    setActivedPagination(false)
                    setLoad(false);
                    return setProducts(response);
                })
                .catch(err => {
                    console.error("Erro ao buscar produtos:", err);
                    setLoad(false);
                });
        }
    };

    useEffect(() => {
        if (parseInt(page) === 0) return;
        setLoad(true);

        if (selectedBrands?.length !== 0 || selectedFabricante?.length !== 0) {
            console.log('pesquisar pela api');

            NewFraga.prodName(
                nomePeca,
                selectedBrands,
                selectedNames,
                selectedModels,
                selectedAllYears,
                selectedEnginer,
                selectedEnginerConfig,
                selectedFabricante,
                idCompany,
                page)
                .then(response => {
                    const container = document.querySelector('.card-container');
                    const target = document.querySelector('#btnSearch');

                    if (container && target) {
                        const offset = 270;
                        const targetOffsetTop = target.offsetTop - offset;

                        container.scrollTo({
                            top: targetOffsetTop,
                            behavior: 'smooth',
                        });
                    }


                    setActivedPagination(true);
                    setProducts(response);
                    setTotalPages(Math.ceil(response.totalFiltered / take));
                    setCurrentPage(page);


                })
                .catch(err => {
                    console.error("Erro ao buscar produtos:", err);
                })
                .finally(() => {
                    setLoad(false);
                });
        } else {
            setLoad(false);
        }
    }, [page]);

   
    return (

        size?.categoria !== 'xlarge' && size?.categoria !== 'large' ?
            (<div>
                <div className='card'>
                    <div className='card-header'>  <h5 className='text-center'>Encontre aqui sua peça!</h5></div>
                    <div className='card-body'>
                        <div className='areaSelect-mobile' >
                            <div className='d-flex justify-content-between align-items-center' >
                                <div className='text-secondary'>Montadora</div>
                                {selectedBrands?.length > 0 && <IoCloseCircle onClick={handleClearBrands} className=' text-danger icon-delet-filter-seler' />}
                            </div>
                            <Select
                                value={selectedOptionBrands}
                                onChange={handleChangeBrands}
                                options={optionsBrands}
                                placeholder="Ex: Ford"
                            />
                        </div>
                        <br></br>
                        <div className='areaSelect-mobile' >
                            <div className='d-flex justify-content-between align-items-center' >
                                <div className='text-secondary'>Veiculo</div>
                                {selectedNames?.length > 0 && <IoCloseCircle onClick={handleClearNames} className=' text-danger icon-delet-filter-seler' />}

                            </div>
                            <Select
                                value={selectedOptionNames}
                                onChange={handleChangeNames}
                                options={optionsNames}
                                placeholder="Ex: BELINA"
                            />
                        </div>
                        <br></br>
                        <div className='areaSelect-mobile'>

                            <div className='d-flex justify-content-between align-items-center' >
                                <div className='text-secondary'>Modelo</div>
                                {selectedModels?.length > 0 && <IoCloseCircle onClick={handleClearModels} className=' text-danger icon-delet-filter-seler' />}

                            </div>

                            <Select
                                value={selectedOptionModels}
                                onChange={handleChangeModels}
                                options={optionsModel}
                                placeholder="Ex: GL"
                            />
                        </div>
                        <br></br>
                        <div className='areaSelect-mobile'>

                            <div className='d-flex justify-content-between align-items-center' >
                                <div className='text-secondary'>Ano Venda</div>
                                {selectedAllYears?.length > 0 && <IoCloseCircle onClick={handleClearYear} className=' text-danger icon-delet-filter-seler' />}
                            </div>

                            <Select
                                value={selectedOptionAllYears}
                                onChange={handleChangeAllYears}
                                options={optionsAllYars}
                                placeholder="Ex: 2002"
                            />
                        </div>
                        <br></br>
                        <div className='areaSelect-mobile'>

                            <div className='d-flex justify-content-between align-items-center' >
                                <div className='text-secondary'>Motor</div>
                                {selectedEnginer?.length > 0 && <IoCloseCircle onClick={handleClearEnginer} className=' text-danger icon-delet-filter-seler' />}
                            </div>


                            <Select
                                value={selectedOptionEnginer}
                                onChange={handleChangeEniner}
                                options={optionsEnginer}
                                placeholder="Ex: 1.8"
                            />
                        </div>
                        <br></br>
                        <div className='areaSelect-mobile' >

                            <div className='d-flex justify-content-between align-items-center' >
                                <div className='text-secondary'>Config. Motor</div>
                                {selectedEnginerConfig?.length > 0 && <IoCloseCircle onClick={handleClearEnginerConfig} className=' text-danger icon-delet-filter-seler' />}
                            </div>

                            <Select
                                value={selectedOptionEnginerConfig}
                                onChange={handleChangeEninerConfig}
                                options={optionsEnginerConfig}
                                placeholder="Ex: 1.5 L VVT"
                            />
                        </div>
                        <br></br>
                    </div>
                </div>
                <br></br>

                <div className=' w-100 d-flex align-items-center cell'>
                    <Select
                        className='w-100'
                        value={selectedOptionFabricates}
                        onChange={handleChangeFabricante}
                        options={optionsFabricantes}
                        placeholder="Filtrar Frabricante"
                    />
                    {selectedFabricante?.length > 0 && <IoCloseCircle style={{ marginLeft: "10px" }} onClick={handleFabricantes} className=' text-danger icon-delet-filter-seler' />}
                </div>
                <br></br>

                <select onChange={(e) => { setOrdenarPreco(e.target.value) }} style={{ width: "230px" }} className=' w-100 form-select'>
                    <option disabled={true}> Ordenar Produtos</option>
                    <option value={1}>Maior Preço</option>
                    <option value={2}>Menor Preço</option>
                </select>

                <br></br>
                <form onSubmit={(e) => { handleNomeTESTE(e); searchParts(e); }} >
                    <input required={required} onChange={(e) => { setNamePeca(e.target.value) }} style={{ marginRight: "10px" }} className='form-control' type="search" placeholder='Pesquisar Complemento' />
                    <br></br>
                    <Button type='submit' className=' btn w-100 btn-warning '>Pesquisar</Button>
                </form>
            </div>)
            :
            (
                <Card style={{ border: "transparent" }}>
                    <Card.Body className='w-100'>
                        <h4 className='text-left'>Encontre aqui sua peça!</h4>
                        <hr></hr>
                        <div className='d-flex justify-content-between w-100 area-selects-seach'>

                            <div className='areaSelect' >
                                <div className='d-flex justify-content-between align-items-center' >
                                    <div className='text-secondary'>Montadora</div>
                                    {selectedBrands?.length > 0 && <IoCloseCircle onClick={handleClearBrands} className=' text-danger icon-delet-filter-seler' />}

                                </div>
                                <Select
                                    value={selectedOptionBrands}
                                    onChange={handleChangeBrands}
                                    options={optionsBrands}
                                    placeholder="Ex: Ford"
                                />
                            </div>

                            <div className='areaSelect' >
                                <div className='d-flex justify-content-between align-items-center' >
                                    <div className='text-secondary'>Veiculo</div>
                                    {selectedNames?.length > 0 && <IoCloseCircle onClick={handleClearNames} className=' text-danger icon-delet-filter-seler' />}

                                </div>
                                <Select
                                    value={selectedOptionNames}
                                    onChange={handleChangeNames}
                                    options={optionsNames}
                                    placeholder="Ex: BELINA"
                                />
                            </div>

                            <div className='areaSelect'>

                                <div className='d-flex justify-content-between align-items-center' >
                                    <div className='text-secondary'>Modelo</div>
                                    {selectedModels?.length > 0 && <IoCloseCircle onClick={handleClearModels} className=' text-danger icon-delet-filter-seler' />}

                                </div>

                                <Select
                                    value={selectedOptionModels}
                                    onChange={handleChangeModels}
                                    options={optionsModel}
                                    placeholder="Ex: GL"
                                />
                            </div>

                            <div className='areaSelect'>

                                <div className='d-flex justify-content-between align-items-center' >
                                    <div className='text-secondary'>Ano Venda</div>
                                    {selectedAllYears?.length > 0 && <IoCloseCircle onClick={handleClearYear} className=' text-danger icon-delet-filter-seler' />}
                                </div>

                                <Select
                                    value={selectedOptionAllYears}
                                    onChange={handleChangeAllYears}
                                    options={optionsAllYars}
                                    placeholder="Ex: 2002"
                                />
                            </div>

                            <div className='areaSelect'>

                                <div className='d-flex justify-content-between align-items-center' >
                                    <div className='text-secondary'>Motor</div>
                                    {selectedEnginer?.length > 0 && <IoCloseCircle onClick={handleClearEnginer} className=' text-danger icon-delet-filter-seler' />}
                                </div>

                                <Select
                                    value={selectedOptionEnginer}
                                    onChange={handleChangeEniner}
                                    options={optionsEnginer}
                                    placeholder="Ex: 1.8"
                                />
                            </div>

                            <div className='areaSelect' >

                                <div className='d-flex justify-content-between align-items-center' >
                                    <div className='text-secondary'>Config. Motor</div>
                                    {selectedEnginerConfig?.length > 0 && <IoCloseCircle onClick={handleClearEnginerConfig} className=' text-danger icon-delet-filter-seler' />}
                                </div>

                                <Select
                                    value={selectedOptionEnginerConfig}
                                    onChange={handleChangeEninerConfig}
                                    options={optionsEnginerConfig}
                                    placeholder="Ex: 1.5 L VVT"
                                />
                            </div>

                        </div>
                        <br></br>
                        <div className='d-flex   w-100 area-selects-seach'>

                            <button onClick={handleFilterEstoque} className={`btn border cell d-flex align-items-center ${filterEstoque ? 'bg-warning' : 'bg-white'}`}>
                                {filterEstoque ? <MdCheckBox style={{ marginRight: "5px" }} /> : <MdCheckBoxOutlineBlank style={{ marginRight: "5px" }} />}  <div>Filtrar Somente em Estoque</div>
                            </button>

                            <div className=' d-flex align-items-center cell'>

                                <Select
                                    value={selectedOptionFabricates}
                                    onChange={handleChangeFabricante}
                                    options={optionsFabricantes}
                                    placeholder="Filtrar Frabricante"
                                />

                                {selectedFabricante?.length > 0 && <IoCloseCircle style={{ marginLeft: "10px" }} onClick={handleFabricantes} className=' text-danger icon-delet-filter-seler' />}


                            </div>
                            <select onChange={(e) => { setOrdenarPreco(e.target.value) }} style={{ width: "230px" }} className='item-filtro-busca form-select'>
                                <option disabled={true}> Ordenar Produtos</option>
                                <option value={1}>Maior Preço</option>
                                <option value={2}>Menor Preço</option>
                            </select>

                        </div>
                        <br></br>
                        <form onSubmit={(e) => { handleNomeTESTE(e); searchParts(e); }} className='d-flex'>
                            <input required={required} onChange={(e) => { setNamePeca(e.target.value) }} style={{ marginRight: "10px" }} className='form-control' type="search" placeholder='Pesquisar Complemento' />
                            <Button type='submit' className='btn-warning '>Pesquisar</Button>
                        </form>
                    </Card.Body>



                </Card >
            )

    )
}

export default FilterSearch

